import * as t from '../types.js';

const initialState = {
  data: null,
  loading: false,
};

const reviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.ADD_REVIEW:
      //   (action.payload);
      return {
        ...state,
      };
    case t.UPDATE_PASSWORD_LOADING:
      //   (action.payload);
      return {
        ...state,
        loading: action.payload.payload,
        data: action.payload.data,
      };

    default:
      return state;
  }
};

export default reviewsReducer;
